module.exports = __webpack_public_path__ + "img/service.3f277576.png";